import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpen, Ruler, Layers, Footprints, CheckSquare } from 'lucide-react';
export function WhatYouGet() {
  const features = [{
    icon: <BookOpen className="w-6 h-6 text-brand-accent" strokeWidth={1.5} data-id="element-229" />,
    title: 'Guía Completa (25 a 40 pag)',
    desc: 'El manual visual paso a paso con ejemplos reales y técnicas aplicables hoy'
  }, {
    icon: <Ruler className="w-6 h-6 text-brand-accent" strokeWidth={1.5} data-id="element-230" />,
    title: 'Mapa de Proporciones',
    desc: 'La regla de los tercios explicada con diagramas simples para tu tipo de cuerpo'
  }, {
    icon: <Layers className="w-6 h-6 text-brand-accent" strokeWidth={1.5} data-id="element-231" />,
    title: 'Sistema de 3 Capas',
    desc: 'El método exacto para crear columnas verticales que estilizan al instante'
  }, {
    icon: <Footprints className="w-6 h-6 text-brand-accent" strokeWidth={1.5} data-id="element-232" />,
    title: 'Guía de Calzado y Accesorios',
    desc: 'Cómo alargar la silueta sin tacones incómodos ni gastar en nuevos zapatos'
  }, {
    icon: <CheckSquare className="w-6 h-6 text-brand-accent" strokeWidth={1.5} data-id="element-233" />,
    title: 'Checklist de 2 Minutos',
    desc: 'El repaso rápido frente al espejo para salir perfecta cada mañana'
  }];
  return <section className="bg-white py-12 sm:py-16 px-4" data-id="element-234">
      <div className="max-w-content mx-auto" data-id="element-235">
        <FadeIn data-id="element-236">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-center text-brand-text mb-10" data-id="element-237">
            Todo lo que incluye Closet Flaco Express
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-12" data-id="element-238">
          {features.map((feature, index) => <FadeIn key={index} delay={index * 0.1} className={index === features.length - 1 ? 'sm:col-span-2 sm:max-w-md sm:mx-auto w-full' : ''} data-id="element-239">
              <div className="bg-brand-bg border-t-4 border-t-brand-accent rounded-b-xl p-6 shadow-sm h-full flex flex-col items-center text-center" data-id="element-240">
                <div className="mb-4 p-3 bg-white rounded-full shadow-sm" data-id="element-241">
                  {feature.icon}
                </div>
                <h3 className="font-bold text-brand-text text-lg mb-2" data-id="element-242">
                  {feature.title}
                </h3>
                <p className="text-brand-text/80 text-sm leading-relaxed" data-id="element-243">
                  {feature.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-244">
          <div className="text-center" data-id="element-245">
            <p className="text-xl sm:text-2xl font-bold text-brand-text" data-id="element-246">
              Valor real:{' '}
              <span className="line-through text-brand-text/40 font-normal mr-2" data-id="element-247">
                $25
              </span>
              <span className="text-brand-accent" data-id="element-248">→ Hoy solo: $8,99</span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}